export const truncateString = (inputString, length, options = {}) => {
  if (inputString.length > length) {
    const ellipse = options.ellipse || ''
    // Cut string
    const shortStr = inputString.substr(0, length - ellipse.length)

    // Cut to last space and Add ellipse
    const spaceIndex = shortStr.lastIndexOf(' ')

    return spaceIndex > 0
      ? `${shortStr.substring(0, shortStr.lastIndexOf(' '))} ${ellipse}`.trim()
      : shortStr.trim()
  }

  return inputString
}
